<template>
  <div v-if="!isIOS" class="pages privacy_pro">
    <div class="container">
      <h1><a id="Pro_0"></a>“画世界Pro”隐私政策</h1>
      <p>
        <strong
          >更新日期：2026年9月3日<br />
          生效日期：2026年9月3日</strong
        >
      </p>
      <p>
        杭州摸鲸科技有限公司（简称“我们”）作为画世界PRO的运营者，我们非常重视保护您的隐私和个人信息，我们将按照法律法规的规定，保护您的个人信息及隐私安全。我们希望通过本《隐私政策》向您清晰地介绍您在使用我们的产品或服务时，我们如何处理您的个人信息，以及我们为您提供的管理、保护这些信息的方式。<br />
        <strong
          >【特别提示】在使用画世界PRO之前，请务必仔细阅读本政策，为实现您选择使用的功能、服务，或为遵守法律法规的要求，我们会处理相关信息。除实现画世界PRO基本功能、服务所需的信息，和根据法律法规要求所必需的信息之外，您可以拒绝我们处理其他信息，但这可能导致我们无法提供对应功能、服务。我们将在隐私政策中逐项说明相关情况，有关您个人信息权益的重要条款已用加粗形式提示，请特别关注，包括但不限于
          个人敏感信息、系统权限、第三方SDK、第三方服务跳转，以及您查阅、复制、更正、删除、撤回授权、注销账号等权利
          。我们会按照最小必要原则处理个人信息。</strong
        ><br />
        除本政策外，在特定场景下，我们将以及时告知的方式（包括但不限于更新本政策、页面提示、弹窗）另行向您详细说明对应信息的处理目的、方式、范围等规则，并在征得您的授权同意后处理。
      </p>
      <blockquote>
        <p>
          本政策将帮助您了解以下内容<br />
          1我们如何收集和使用个人信息<br />
          2我们如何存储个人信息<br />
          3数据使用过程中涉及的合作方以及转移、公开个人信息<br />
          4我们如何保护个人信息安全<br />
          5我们如何处理未成年人的个人信息<br />
          6您的权利<br />
          7适用范围<br />
          8其他<br />
          9如何联系我们
        </p>
      </blockquote>
      <h3><a id="1_20"></a>1我们如何收集和使用个人信息</h3>
      <h4><a id="11__21"></a>1.1 帐号服务</h4>
      <p>
        <strong>1.1.1 注册、登录</strong><br />
        您可以通过画世界账号登录画世界PRO，当您通过画世界账号登录时，我们将收集您的<strong>账号昵称、头像</strong>，用于您登录账号时验证您的身份。<br />
        当您注册、登录画世界PRO以及使用相关服务时，为了帮您顺利完成注册/登录流程，您需要向我们提供您的<strong>手机号码</strong>、手机登录密码信息。收集手机号码是履行国家法律法规关于网络实名制（真实身份信息认证）要求的必要信息，如果您拒绝提供手机号码用于注册、登录，我们可能无法为您提供信息发布图文和上传素材功能。<br />
        您可以通过手机号码创建帐号，可以完善相关的<strong>网络身份识别信息（头像、昵称、密码、地区）</strong>。<br />
        一键登录：基于我们与通信运营商的合作，当您使用“一键登录”功能时，经过您的同意，运营商会将您的手机号码发送给我们，便于我们为您提供免于密码或动态验证码核验的快捷登录服务。在部分Android设备上，我们会在您使用一键登录时申请<strong>手机状态读取权限（android.permission.READ_PHONE_STATE）</strong>，用于判断当前联网SIM卡通道、锁定提供服务的手机号码并提升多SIM卡场景下一键登录的准确性。如果你不希望使用“一键登录”功能，可以通过其他方式注册、登录画世界PRO。<br />
        如果您忘记了您画世界PRO的登录方式，可以使用找回密码功能。为保障您帐号的安全，我们需要您填写相关信息以进行验证，必要时可能通过真实身份信息验证等方式验证您的身份。<br />
        <strong>1.1.2 账号资料维护</strong><br />
        为便于您在画世界PRO内对个人资料进行查看与维护，您可自主选择填写您的<strong>性别、昵称、头像、地区</strong>。如您未填写，不影响您使用我们产品或服务的基本功能。<br />
        您在上传/更换头像时，我们会请求您的<strong>相机、相册/照片与视频</strong>权限，并在经您授权后收集您上传/更换的<strong>图片信息</strong>。<br />
        <strong>1.1.3画世界PRO统一账号和关联产品</strong><br />
        画世界PRO各关联产品均使用统一的画世界帐号服务，包括不限于画世界、画世界PRO、画世界PC版、熊猫绘画以及画世界官方网站。
        您可以使用画世界帐号便捷地登录、使用画世界关联产品，和对应产品的服务或功能。如您在任一款产品中对账号信息（包括账号密码、手机号码）进行修改，该修改将会自动同步至您的统一账号。您理解并同意，如您在任一款产品中实施账户注销，将可能会影响您使用其他产品。
      </p>
      <h4><a id="12__33"></a>1.2 绘画工具</h4>
      <p>
        本应用运行时会读取媒体影音数据用于编辑照片、音频和显示草稿文件。使用账号登录、获取应用数据、同步草稿、发布内容、上传或下载文件等联网功能时，我们会使用<strong>网络权限（android.permission.INTERNET）</strong>，用于连接服务器并获取或传输实现对应功能所需的数据。<br />
        您在使用画世界PRO查看草稿箱内容、创建草稿、上传草稿、导出作品、笔刷保存、上传笔刷时，我们会申请您授权<strong>读取/写入外置存储、存储/媒体影音</strong>权限，用以保存和读取您的<strong>绘画数据、草稿数据、笔刷数据、图片、视频、音频</strong>，如果您拒绝将无法使用对应功能。其中，在草稿导入及草稿管理相关功能中，导入草稿需要存储草稿文件并在导入后在草稿箱可见；选择草稿、草稿排序、新建文件夹、访问最近删除草稿等功能需要草稿箱草稿或相关文件夹可见。<br />
        您在使用图片创建画布或导入图片到画布、临摹参考、发布信息、上传/更换头像、设置画题封面或创作点子封面，以及在实名认证中拍摄认证材料或进行人脸核验时，我们会根据具体功能申请您的<strong>相机、相册/照片与视频</strong>权限，用于拍照、访问相册以及读取您主动选择的图片或视频。如您拒绝授权，将无法使用对应功能，但不影响您使用画世界PRO的其他功能。您可以在设备的设置功能中选择关闭部分或全部权限。在不同设备中，上述权限的开启和关闭方式可能有所不同。<br />
        您在IM私聊中发送语音信息、为视频配音或在制作动画添加音频时选择录音，我们会申请您授权<strong>麦克风</strong>权限，用以录制并发送您主动录入的声音数据；如果您拒绝，将无法使用对应的语音、配音或录音功能，但不影响其他功能。<br />
        在视频播放等需要识别屏幕方向的场景中，我们可能调用<strong>传感器信息</strong>用于识别设备方向；我们将尽量仅在相关功能使用期间启用，减少不必要的传感器数据处理。<br />
        在接入特定数位板和手写笔时，我们会读取<strong>蓝牙（Bluetooth）信息</strong>，为您提供更好的绘画输入设备支持。客户端在使用时可能读取或写入<strong>剪切板信息</strong>，用于实现复制颜色、复制链接、分享等功能。
      </p>
      <h4><a id="13__40"></a>1.3 问题反馈与客服</h4>
      <p>
        当您通过“问题反馈”、客服或投诉举报入口联系我们时，我们可能会根据您主动提交的内容处理<strong>问题描述、联系方式（例如手机号、QQ、微信号）、您上传的截图、图片、视频、笔刷文件或其他附件，以及与问题定位相关的设备信息、系统版本、应用版本、日志信息</strong>，用于定位、核实和解决您反馈的问题，与您沟通处理进度和结果，改进产品功能和服务质量，并保障账号、交易和服务安全。QQ、微信号等联系方式由您自主填写；如该字段不是解决问题所必需，您不填写不影响提交基础反馈，但可能影响我们与您进一步沟通处理结果。<br />
        当您在问题反馈中上传截图、图片、视频、笔刷文件或其他附件时，我们会申请您授权<strong>相机、相册/照片与视频、存储/媒体影音</strong>权限，用于读取您主动选择或上传的附件。
      </p>
      <h4><a id="14__43"></a>1.4 下单与支付</h4>
      <p>
        当您在画世界PRO中购买商品或服务时（包含开通/续费VIP），在支付过程中，我们可能会收集您的<strong>第三方支付账号（支付宝账号、微信账号、银联账号及有关账号）</strong>。为便于协助您顺利完成交易、查询订单信息，以及向您提供客户服务和保障您的交易安全，我们需要根据商品或服务类型收集如下部分或全部的个人信息：包括<strong>订单编号、交易金额、下单时间、订单状态、支付方式、支付账号、支付状态</strong>。这些信息是支付功能所必需的信息，拒绝提供将导致您无法使用该功能，但不影响其他功能的正常使用。
      </p>
      <h4><a id="15__45"></a>1.5 运营与安全运行</h4>
      <p>
        我们致力于为您提供安全、可信的产品与使用环境，提供优质而可靠的服务与信息是我们的核心目标。为了维护相关产品或服务的正常稳定运行，保护您或其他用户或公众的安全及合法利益，我们会收集如下必要信息：<br />
        1.5.1
        为了解决不同设备的兼容问题，我们会获取您的<strong>设备信息</strong>（包括：硬件型号、设备分辨率、操作系统版本号）、软件版本号、<strong>CPU序列号</strong>，确保您在不同型号的设备上都可以获得最优的使用体验。<br />
        1.5.2
        为了保障帐号安全和防止异常活动，我们会收集您的<strong>可变设备标识符（AndroidID、OAID、VAID、AAID、GAID）</strong>、<strong>传感器信息</strong>、<strong>应用来源</strong>、<strong>任务列表数据、手机BootID、已安装应用列表或正在运行的进程信息</strong>、<strong>应用程序的总体运行</strong>、使用情况与频率、<strong>总体安装使用情况</strong>、服务日志。对于获取应用基本信息、应用元数据、应用签名信息、<strong>已安装应用列表或已安装应用信息列表</strong>等系统信息的调用，我们会通过缓存等方式降低调用频次，并按功能必要和最低频次处理。<br />
        1.5.3
        为了提升服务质量和运行稳定性，我们会收集<strong>网络相关信息</strong>（<strong>WLAN接入点（SSID，BSSID）</strong>、<strong>IP地址</strong>、<strong>网络接入方式、状态、参数、信号强度、DHCP信息</strong>、<strong>运营商信息、SIM卡状态</strong>、手机网络类型）、应用崩溃情况、性能数据，用于优化和提升产品的流畅性和稳定性。<br />
        1.5.4在使用分享和一键登录时，我们会收集<strong>粗略的定位信息</strong>，用于精细化运营和设备安全检测。
      </p>
      <h4><a id="16Cookie_51"></a>1.6Cookie等同类技术的使用</h4>
      <p>
        Cookie
        和<strong>设备信息</strong>标识等同类技术是互联网中普遍使用的技术。当您使用画世界PRO及相关服务时，我们可能会使用相关技术向您的设备发送一个或多个Cookie
        或匿名标识符，以收集、标识您访问、使用本产品时的信息。我们承诺，不会将Cookie
        用于本隐私政策所述目的之外的任何其他用途。我们使用Cookie
        和同类技术主要为了实现以下功能或服务：<br />
        保障产品与服务的安全、高效运转：我们可能会设置认证与保障安全性的Cookie
        或匿名标识符，使我们确认您是否安全登录服务，或者是否遇到盗用、欺诈及其他不法行为。这些技术还会帮助我们改进服务效率，提升登录和响应速度。<br />
        帮助您获得更轻松的访问体验：使用此类技术可以帮助您省去重复填写个人信息、输入搜索内容的步骤和流程（示例：记录搜索、表单填写）。
      </p>
      <h4><a id="17__55"></a>1.7 服务内容的变更</h4>
      <p>
        请您了解，随着我们业务的发展，可能会调整画世界PRO提供的产品或服务。如调整变化后的产品或服务所处理个人信息的目的、方式和范围发生变化的，我们会通过推送消息、邮件、弹窗、蓝点提示等方式再次向您告知，并征得您的同意。
      </p>
      <h4><a id="18__57"></a>1.8 广告（含个性化广告）</h4>
      <p>
        我们可能与广告的服务商、供应商和其他合作伙伴以及与我们达成推广合作的合作伙伴（合称“合作方”）共享分析<strong
          >去标识化的设备信息（Android ID、IDFA、OAID）</strong
        >，广告数据（曝光、点击、转化数据），<strong>设备信息</strong>（设备型号、系统语言、屏幕高宽、屏幕方向），应用及使用数据（应用包名、操作日志），连接的<strong>WIFI</strong>。<strong>请您放心这些信息难以或无法与您的真实身份相关联。这些信息将帮助我们分析、衡量广告、推广和相关服务的有效性</strong>。<br />
        当您使用创新广告交互功能（摇动、扭动、扭转设备、滑动、点击）时，我们可能会调用设备的<strong>陀螺仪、加速度、重力传感器</strong>以识别判断您的设备状态和主动交互动作。<br />
        若您不想接受个性化广告服务，您可以在我们的产品服务的相关功能设置页面开启/关闭个性化广告。个性化广告设置路径为：“我的-通用设置-个性化广告管理”。若您选择关闭，您看到的广告数量不会减少，但本产品将不再向您展示个性化广告，您看到的广告将可能与您的偏好相关度降低。
      </p>
      <h4><a id="19_61"></a>1.9依法豁免征得同意处理个人信息</h4>
      <p>
        请您理解，在下列情形中，根据法律法规，我们处理您的个人信息无需征得您的授权同意。<br />
        a) 根据您的要求订立或履行合同所必需；<br />
        b)
        为履行法定职责或者法定义务所必需，例如与国家安全、国防安全、与刑事侦查、起诉、审判和判决执行等直接相关的法定职责或者法定义务；<br />
        c)
        为应对突发公共卫生事件，或者紧急情况下为保护自然人的生命健康和财产安全所必需；<br />
        d)
        为公共利益实施新闻报道、舆论监督等行为，在合理的范围内处理个人信息；<br />
        e)
        在合理的范围内处理您自行公开的个人信息，或者其他已经合法公开的个人信息（如合法的新闻报道、政府信息公开等渠道合法公开的个人信息）；<br />
        f) 法律法规规定的其他情形。
      </p>
      <h3><a id="2_69"></a>2我们如何存储个人信息</h3>
      <h4><a id="21_70"></a>2.1信息存储的地点</h4>
      <p>
        <strong
          >我们依照法律法规的规定，将在境内运营过程中收集和产生的您的个人信息存储于中华人民共和国境内。目前，我们不会将上述信息传输至境外，如果我们向境外传输，我们将会遵循国家相关规定，征求您的同意</strong
        >。
      </p>
      <h4><a id="22_72"></a>2.2存储期限</h4>
      <p>
        我们仅在为提供画世界PRO及服务之目的所必需的期间内保留您的个人信息，例如，您发布的图文、音视频等信息，在您未撤回、删除或未注销账号期间，我们会保留相关信息。超出必要期限后，我们将对您的个人信息进行删除或匿名化处理，但法律法规另有规定的除外。
      </p>
      <h3>
        <a id="3_74"></a>3数据使用过程中涉及的合作方以及转移、公开个人信息
      </h3>
      <h4><a id="31_75"></a>3.1数据使用过程中涉及的合作方</h4>
      <p>
        <strong>3.1.1基本原则</strong><br />
        我们与合作方合作过程中，将遵守以下原则：<br />
        a) 合法原则：涉及数据处理活动的，应当遵守合法原则。<br />
        b)
        正当与最小必要原则：数据使用必须具有正当目的，且应以达成目的必要为限。<br />
        c) 安全审慎原则：
        我们将审慎评估合作方使用数据的目的，对这些合作方的安全保障能力进行综合评估，并要求其遵循合作法律协议。我们会对合作方获取信息的软件工具开发包（SDK）、应用程序接口（API）进行严格的安全监测，以保护数据安全。您可以阅读<a
          href="https://staticpro.mjing.art/hsj/agreement/#/opensource/hsjpro/android"
          target="_blank"
          >开源软件声明</a
        >，以了解画世界PRO使用的开源SDK具体情况。为实现登录、支付、分享、广告、统计分析、账号安全、崩溃排查、设备识别、云备份等功能，我们可能接入第三方SDK或与第三方服务提供方合作。我们会在第三方SDK清单或第三方信息共享清单中列明第三方名称、SDK名称、处理目的、涉及的信息类型、收集方式、权限及第三方隐私政策链接。<br />
        <strong>3.1.2第三方SDK清单</strong>
      </p>
      <table>
        <thead>
          <tr>
            <th>SDK名称</th>
            <th>SDK所属公司</th>
            <th>使用目的</th>
            <th>收集信息与所需权限</th>
            <th>收集方式</th>
            <th>第三方隐私政策链接</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td>MobTech ShareSDK</td>
            <td>上海掌之淘信息技术有限公司</td>
            <td>为用户提供社交分享、第三方登录社交分享、第三方登录服务</td>
            <td>
              系统运行信息（设备平台、系统版本、设备型号、设备厂商、设备品牌、屏幕分辨率），社交平台OpenID（第三方账号），应用列表信息，网络状态信息（
              IP地址 、运营商信息、WiFi信息、基站信息、 SSID、BSSID
              ），地理位置信息，设备标识信息：iOS广告标识符（IDFA）、匿名设备标识符(OAID)，读SDCard/外部存储文件访问
            </td>
            <td>SDK自行采集</td>
            <td>
              <a
                href="https://www.mob.com/wiki/detailed?wiki=638&amp;id=14"
                target="_blank"
                >《ShareSDK隐私政策》</a
              >
            </td>
          </tr>
          <tr>
            <td>MobTech SMSSDK</td>
            <td>上海掌之淘信息技术有限公司</td>
            <td>短信验证功能</td>
            <td>
              系统运行信息（设备平台、系统版本、设备型号、设备厂商、设备品牌、屏幕分辨率），网络状态信息（
              IP地址 、运营商信息、WiFi信息、基站信息、 SSID、BSSID
              ），应用列表信息，地理位置信息，手机号码，设备标识信息：iOS广告标识符（IDFA）、匿名设备标识符(OAID)，SIM卡状态
            </td>
            <td>SDK自行采集</td>
            <td>
              <a
                href="https://www.mob.com/wiki/detailed?wiki=596&amp;id=23"
                target="_blank"
                >《SMSSDK隐私政策》</a
              >
            </td>
          </tr>
          <tr>
            <td>
              MobTech 秒验：FlyVerify SDK（含 cn.fly.verify、cn.fly.tools 组件）、zztsdk/zztcore(秒验一键登录)
            </td>
            <td>上海掌之淘信息技术有限公司</td>
            <td>用于手机号一键登录、号码认证及登录安全校验</td>
            <td>
              网络状态信息、手机号码、运营商信息、SIM卡状态、SIM卡卡槽信息、手机网络类型、系统运行信息、设备标识信息（IDFA、OAID、Advertising
              ID）、粗略地理位置信息、精细地理位置信息、应用列表信息、设备信息等，用于完成号码认证和安全风控
            </td>
            <td>SDK自行采集</td>
            <td>
              <a
                href="https://www.mob.com/wiki/detailed?wiki=639&amp;id=78"
                target="_blank"
                >《MobTech隐私政策》</a
              >
            </td>
          </tr>
          <tr>
            <td>talkingdata</td>
            <td>北京腾云天下科技有限公司</td>
            <td>匿名统计分析</td>
            <td>
              网络权限、读写储存权限，唯一设备识别符：安卓端（OAID、Android
              ID、ODID）,IOS端（IDFV、IDFA），鸿蒙端(OAID、ODID、AAID)， IP地址
              、设备型号、网络信息（WiFi网络或移动网络的连接状态、连接WiFi的BSSID或SSID信息），获取正在运行的进程、运营商信息、SIM卡状态、CPU序列号、WiFi参数、WIFI信号强度、DHCP信息、手机网络类型
            </td>
            <td>SDK自行采集</td>
            <td>
              <a
                href="https://www.talkingdata.com/privacy.jsp?languagetype=zh_cn"
                target="_blank"
                >《talkingdata隐私政策》</a
              >
            </td>
          </tr>
          <tr>
            <td>支付宝支付</td>
            <td>支付宝（中国）网络技术有限公司</td>
            <td>支付宝付款</td>
            <td>
              Android ID、OAID、AAID、VAID、 SSID、BSSID
              ；系统设置、系统属性、设备型号、设备品牌、操作系统；IP
              地址、网络类型、运营商信息、Wi-Fi 状态、Wi-Fi 参数、Wi-Fi
              列表、传感器列表、软件安装列表，读SDCard/外部存储文件访问
            </td>
            <td>SDK自行采集</td>
            <td>
              <a
                href="https://opendocs.alipay.com/common/02kiq3"
                target="_blank"
                >《支付宝隐私政策》</a
              >
            </td>
          </tr>
          <tr>
            <td>微信OpenSDK</td>
            <td>深圳市腾讯计算机系统有限公司、财付通支付科技有限公司</td>
            <td>微信账号登录；APP内容分享到微信好友、朋友圈；微信支付</td>
            <td>
              网络权限、读写储存权限、唯一设备识别码（设备的MAC、IMEI、OAID、AAID、VAID、UUID）、硬件设备型号、终端系统信息、陀螺仪
              传感器信息 、软件安装信息、 IP地址
              、移动网络信息（Wi-Fi信息）、设备位置信息、分享信息内容（剪切板、相册图片），已安装应用列表
            </td>
            <td>SDK自行采集</td>
            <td>
              <a
                href="https://support.weixin.qq.com/cgi-bin/mmsupportacctnodeweb-bin/pages/RYiYJkLOrQwu0nb8#__section1"
                target="_blank"
                >《微信Open SDK个人信息处理规则》</a
              >
            </td>
          </tr>
          <tr>
            <td>QQ互联SDK</td>
            <td>深圳市腾讯计算机系统有限公司</td>
            <td>APP内容分享到QQ好友、QQ空间</td>
            <td>
              设备型号信息、 剪切板信息
              、内存卡权限、特定应用（QQ、TIM）的安装情况，相册、内存卡权限
            </td>
            <td>SDK自行采集</td>
            <td>
              <a
                href="https://wiki.connect.qq.com/qq%e4%ba%92%e8%81%94sdk%e9%9a%90%e7%a7%81%e4%bf%9d%e6%8a%a4%e5%a3%b0%e6%98%8e"
                target="_blank"
                >《QQ互联SDK隐私保护声明》</a
              >
            </td>
          </tr>
          <tr>
            <td>微博SDK</td>
            <td>北京微梦创科网络技术有限公司</td>
            <td>APP内容分享到微博</td>
            <td>设备型号，用户分享时，获取用户选择的图片或视频</td>
            <td>SDK自行采集</td>
            <td>
              <a href="https://open.weibo.com/wiki/Sdk/privacy" target="_blank"
                >《微博个人信息保护政策》</a
              >
            </td>
          </tr>
          <tr>
            <td>阿里云存储(OSS)</td>
            <td>阿里云计算有限公司</td>
            <td>保存作品图片、保存用户头像数据</td>
            <td>
              设备型号、设备操作系统信息、Android：android.permission.INTERNET、android.permission.WRITE_EXTERNAL_STORAGE、android.permission.READ_EXTERNAL_STORAGE权限
            </td>
            <td>SDK自行采集</td>
            <td>
              <a
                href="https://terms.alicdn.com/legal-agreement/terms/privacy_policy_full/20240202100310511/20240202100310511.html?spm=a2c4g.11186623.0.0.7aaf4e4c6gRs94"
                target="_blank"
                >《对象存储SDK隐私政策》</a
              >
            </td>
          </tr>
          <tr>
            <td>联通一键登录</td>
            <td>中国联合网络通信有限公司</td>
            <td>一键登录</td>
            <td>
              设备信息
              （网络类型、网络地址、运营商类型、本机手机号、手机设备类型、手机操作系统、硬件厂商）、网络权限、
              IP地址 、获取手机信息权限、运营商信息，SIM卡状态
            </td>
            <td>SDK自行采集</td>
            <td>
              <a
                href="https://msv6.wosms.cn/html/oauth/protocol2.html"
                target="_blank"
                >《联通认证服务隐私政策》</a
              >
            </td>
          </tr>
          <tr>
            <td>移动一键登录</td>
            <td>中移互联网有限公司</td>
            <td>一键登录</td>
            <td>
              设备信息
              （网络类型、ip地址、运营商类型、本机号码信息、SIM卡状态、手机设备类型、手机操作系统、硬件厂商、OAID、AAID、VAID）,网络权限、读写储存权限、运营商信息，已安装应用列表
            </td>
            <td>SDK自行采集</td>
            <td>
              <a
                href="https://wap.cmpassport.com/resources/html/contract.html"
                target="_blank"
                >《移动统一认证服务条款》</a
              >
            </td>
          </tr>
          <tr>
            <td>电信一键登录</td>
            <td>世纪龙信息网络有限责任公司</td>
            <td>一键登录</td>
            <td>
              设备信息 （网络类型、 IP地址
              、运营商类型、本机手机号、手机设备类型、手机操作系统、硬件厂商），网络权限、获取手机信息权限、运营商信息、设备标识符(IDFV、Android
              ID)信息
            </td>
            <td>SDK自行采集</td>
            <td>
              <a
                href="https://e.189.cn/sdk/agreement/show.do?order=2&amp;type=main&amp;appKey=&amp;hidetop=true&amp;returnUrl="
                target="_blank"
                >《天翼账号认证SDK隐私政策》</a
              >
            </td>
          </tr>
          <tr>
            <td>数美SDK</td>
            <td>北京数美时代科技有限公司</td>
            <td>账户与设备风险保护</td>
            <td>
              设备信息
              ：设备品牌、设备制造商、设备型号、设备名称、设备系统类型及版本信息、设备基本设置、设备环境；设备标识信息：Android
              ID、IDFV、IDFA、OAID、AAID、VAID；
              设备网络信息：网络的接入形式、周边WIFI列表、BSSID、 IP地址
              、SSID、网络运营商信息、网络连接状态、设备 传感器信息
              ；设备应用信息：SDK宿主应用包名及版本号、运行中进程信息
            </td>
            <td>SDK自行采集</td>
            <td>
              <a
                href="https://www.ishumei.com/legal/cn/privacy.html"
                target="_blank"
                >《数美科技隐私政策》</a
              >
            </td>
          </tr>
          <tr>
            <td>Bugly SDK</td>
            <td>深圳市腾讯计算机系统有限公司</td>
            <td>本SDK运行时对发生的的故障问题进行排查、分析、解决</td>
            <td>
              Android端：手机型号、手机品牌、
              Android系统版本、Android系统api等级、厂商系统版本、cpu架构类型、设备是否
              root、磁盘空间占用大小、sdcard空间占用大小、内存空间占用大小、网络类型、应用当前正在运行的进程名和PID，android.permission.INTERNET，android.permission.ACCESS_NETWORK_STAT权限，网络权限、网络状态
            </td>
            <td>SDK自行采集</td>
            <td>
              <a
                href="https://privacy.qq.com/document/preview/fc748b3d96224fdb825ea79e132c1a56"
                target="_blank"
              >
                《Bugly SDK个人信息保护规则》</a
              >
            </td>
          </tr>
          <tr>
            <td>网易易盾</td>
            <td>杭州网易智企科技有限公司</td>
            <td>获取OAID</td>
            <td>
              基础信息：协议版本号、平台、包名、操作系统版本、Model
              、APP版本号、序列号、手机品牌、运营商， 设备信息
              ：IMEI、手机MAC地址、AndroidId、电源数量、是否存在SIM卡、指令架构、屏幕高、屏幕宽，环境信息：网络连接类型、USB调试模式、重力感应检测、电量获取、充电状态，行为数据：用户在终端屏幕中点击、拖动的行为数据，读取其他内容库、VAID、AAID
            </td>
            <td>SDK自行采集</td>
            <td>
              <a
                href="https://support.dun.163.com/documents/413846598587424768?docId=507376333387018240"
                target="_blank"
                >《网易易盾隐私政策》</a
              >
            </td>
          </tr>
          <tr>
            <td>百度网盘开放云盘</td>
            <td>北京度友科技有限公司</td>
            <td>登录百度账号，备份草稿/笔刷/色卡到云盘</td>
            <td>
              设备信息
              （硬件型号、操作系统版本及系统情况、设备配置、IMEI、IMSI、网络设备硬件地址MAC、供应商标识符IDFV、移动设备识别码MEID、匿名设备标识符OAID、VAID、AAID
              、集成电路卡识别码ICCID 、Android
              ID、硬件型号）、网络信息（电信运营商、WIFI信息）、本地文件读写/存储权限、设备应用安装列表、设备
              传感器信息
            </td>
            <td>SDK自行采集</td>
            <td>
              <a
                href="https://pan.baidu.com/union/protocol/hl56pr0w6"
                target="_blank"
                >《百度网盘开放平台用户隐私协议》</a
              >
            </td>
          </tr>
          <tr>
            <td>BeiZi SDK</td>
            <td>上海倍孜网络技术有限公司</td>
            <td>推送程序化广告</td>
            <td>
              设备/网络/系统信息（设备品牌、设备型号、设备时区、设备语言、系统版本、网络类型、UserAgent信息、屏幕高宽、屏幕方向、屏幕DPI信息、系统更新时间、开机时间、磁盘空间、物理内存、运营商、sim卡状态、
              传感器信息 、掠过手势内容）、网络权限、设备标识符（Android:Android
              ID、OAID、VAID、AAID、GAID，iOS:IDFV、IDFA）、 IP地址 、设备
              传感器信息 、运营商信息，已安装应用列表
            </td>
            <td>SDK自行采集</td>
            <td>
              <a
                href="https://sdkdoc.beizi.biz/#/zh-cn/guide/UsePrivacy"
                target="_blank"
                >《BeiZi隐私政策》</a
              >
            </td>
          </tr>
          <tr>
            <td>腾讯优量汇</td>
            <td>深圳市腾讯计算机系统有限公司</td>
            <td>推送程序化广告</td>
            <td>
              设备/网络/系统信息（设备制造商、品牌、设备型号、操作系统版本、屏幕分辨率、屏幕方向、屏幕DPI、
              IP地址 、时区、网络类型、运营商）、
              设备标识符（OAID、VAID、AAID、Android_ID、IDFV、IDFA，鸿蒙端：ODID），设备
              传感器信息
              、传感器列表、SSID、运营商信息，已安装应用列表、读SDCard/外部存储文件访问、SD卡创建目录、SD卡查询文件列表、WiFi参数
            </td>
            <td>SDK自行采集</td>
            <td>
              <a
                href="https://e.qq.com/dev/help_detail.html?cid=2005&amp;pid=5983"
                target="_blank"
                >《优量汇 SDK个人信息保护规则》</a
              >
            </td>
          </tr>
          <tr>
            <td>章鱼SDK</td>
            <td>北京圣盈科技有限公司</td>
            <td>推送程序化广告</td>
            <td>
              设备信息
              （设备品牌、设备型号、设备时区、设备语言、系统版本、开发者应用名、应用版本号、应用包名、网络类型、UserAgent信息、网络状态、崩溃信息、性能数据、屏幕高宽、屏幕方向、屏幕DPI信息、系统更新时间、开机时间、磁盘空间、物理内存、运营商），网络权限，设备标识符(OAID、VAID、AAID、GAID、Android
              ID、IDFV、IDFA）,设备 传感器信息 ，运营商信息，已安装应用列表
            </td>
            <td>SDK自行采集</td>
            <td>
              <a
                href="https://doc.adintl.cn/docs/SDK%E9%9A%90%E7%A7%81%E6%94%BF%E7%AD%96/UsePrivacy/"
                target="_blank"
                >《Octopus平台隐私政策》</a
              >
            </td>
          </tr>
          <tr>
            <td>美数广告SDK</td>
            <td>北京美数信息科技有限公司</td>
            <td>推送程序化广告</td>
            <td>
              设备信息
              （设备品牌、型号、软件系统版本、屏幕密度、屏幕分辨率、设备语⾔、可⽤存储空间⼤⼩）、设备标识符（AndroidID、OAID、IDFV、CAID、IDFA、VAID、AAID，鸿蒙端：ODID）、设备
              传感器信息 、网络权限、BSSID、 IP地址
              、SSID、运营商信息，已安装应用列表、CPU序列号、GAID、手机BootID
            </td>
            <td>SDK自行采集</td>
            <td>
              <a
                href="https://wwww.atdplus.cn/html/sdk-privacy-agreement/%E7%BE%8E%E6%95%B0SDK%E7%94%A8%E6%88%B7%E9%9A%90%E7%A7%81%E6%94%BF%E7%AD%96.html"
                target="_blank"
                >《美数隐私政策》</a
              >
            </td>
          </tr>
          <tr>
            <td>腾讯图灵盾SDK</td>
            <td>深圳市腾讯计算机系统有限公司</td>
            <td>推送程序化广告</td>
            <td>
              网络状态、系统设置、系统属性、设备型号、操作系统、WIFI状态、
              IP地址 、运营商信息，Android：OAID、VAID、AAID、Android
              ID，iOS：IDFA、IDFV，已安装应用列表、SIM卡状态、读SDCard/外部存储文件访问
            </td>
            <td>SDK自行采集</td>
            <td>
              <a
                href="https://privacy.qq.com/document/preview/5331f064a91a47eb93993fdacb91c8f7"
                target="_blank"
                >《腾讯图灵盾风险识别SDK隐私政策》</a
              >
            </td>
          </tr>
          <tr>
            <td>脉盟SDK</td>
            <td>上海孛樊信息科技有限公司</td>
            <td>推送程序化广告</td>
            <td>
              网络权限，设备制造商、设备品牌、型号、软件系统版本、分辨率、网络状态、重力传感器、蓝牙地址、设备标识符（OAID、IMSI、ICCID、MEID）、设备
              传感器信息
              ，应用信息：开发者应用名、应用包名、版本号、应用前后台状态。其他信息：运营商信息、设备时区、设备语言，广告数据（展示、点击、转化数据）、崩溃数据，已安装应用列表、SIM卡状态
            </td>
            <td>SDK自行采集</td>
            <td>
              <a
                href="https://static.adwangmai.com/privacy-MaxMindSDK.html"
                target="_blank"
                >《脉盟SDK隐私政策》</a
              >
            </td>
          </tr>
          <tr>
            <td>xCrash SDK</td>
            <td>开源SDK</td>
            <td>收集应用崩溃信息</td>
            <td>获取应用进程列表</td>
            <td>SDK自行采集</td>
            <td>
              <a
                href="https://github.com/iqiyi/xCrash/blob/master/README.zh-CN.md"
                target="_blank"
                >《xCrash官方项目及数据处理说明》</a
              >
            </td>
          </tr>
        </tbody>
      </table>
      <p>
        <strong>3.1.3 委托处理</strong><br />
        <strong
          >对于委托处理个人信息的场景，我们会与受托合作方根据法律规定签署相关处理协议，并对其个人信息使用活动进行监督。</strong
        ><br />
        <strong>3.1.4共同处理</strong><br />
        <strong
          >对于共同处理个人信息的场景，我们会与合作方根据法律规定签署相关协议并约定各自的权利和义务，确保在使用相关个人信息的过程中遵守法律的相关规定、保护数据安全。若具体功能和场景中涉及由我们的关联方、第三方提供服务，则合作方范围包括我们的关联方与第三方。</strong
        ><br />
        <strong>3.1.4.1实现广告相关的信息共享</strong><br />
        为实现程序化广告推送，我们可能会与广告合作伙伴（包括广告主和其他广告服务提供商）共享去标识化或匿名化处理后的信息，以帮助其在不识别您个人身份的前提下提升广告的有效触达率。未经您授权，我们不会将您的个人身份信息（即可以识别您身份的信息，例如<strong>姓名或手机号码</strong>）与广告合作伙伴共享。
      </p>
      <h4><a id="32_114"></a>3.2活动参与</h4>
      <p>
        当您选择参加我们举办的营销活动时，经过您的同意，我们与合作方可能需要使用您的<strong>姓名、通信地址、联系方式、银行账号</strong>信息，以便合作方向您兑现活动奖励。当您参与我们和关联方共同举办的营销活动时，可能会在多个参与活动的移动应用程序（简称“活动平台”）之间同步您参与活动的帐号（含标识符）、参与成绩、进度、收益等信息，以保障您在活动中获得完整的服务体验。
      </p>
      <h4><a id="33__116"></a>3.3 实现安全与统计分析</h4>
      <p>
        a)
        保障使用安全：我们非常重视产品和服务的安全性，为保障画世界PRO用户的正当合法权益免受不法侵害，我们的合作方可能会使用必要的设备、帐号及日志信息。<br />
        b）分析产品情况：为分析画世界PRO的产品和服务的稳定性，提供分析服务的合作方可能需要使用服务情况（崩溃、闪退记录）、设备标识信息、应用<strong>总体安装使用情况</strong>等信息。<br />
        c)
        学术科研：为提升相关领域的科研能力，促进科技发展水平，我们在确保数据安全与目的正当的前提下，可能会与合作的科研院所、高校等机构使用去标识化或匿名化的数据。
      </p>
      <h4><a id="34__120"></a>3.4 运营主体变更</h4>
      <p>
        随着业务的持续发展，我们将有可能进行合并、收购、资产转让，您的个人信息有可能因此而被转移。在发生前述变更时，我们将按照法律法规及不低于本隐私政策所载明的安全标准要求继受方保护您的个人信息，继受方变更原先的处理目的、处理方式的，我们将要求继受方重新征得您的授权同意。
      </p>
      <h4><a id="35_122"></a>3.5停止运营</h4>
      <p>
        如果我们停止运营产品或服务，将及时停止继续收集您的个人信息。我们会逐一送达通知或以公告的形式向您发送停止运营的告知，并对我们所持有的与已关停的产品或服务相关的个人信息进行删除或匿名化处理。
      </p>
      <h4><a id="36__124"></a>3.6 依法豁免征得您的授权同意的情形</h4>
      <p>
        请您理解，在下列情形中，根据法律法规及国家标准，合作方使用，或我们转移、公开您的个人信息无需征得您的授权同意：<br />
        a) 根据您的要求订立或履行合同所必需；<br />
        b)
        为履行法定职责或者法定义务所必需，例如与国家安全、国防安全、与刑事侦查、起诉、审判和判决执行等直接相关的法定职责或者法定义务；<br />
        c)
        为应对突发公共卫生事件，或者紧急情况下为保护自然人的生命健康和财产安全所必需；<br />
        d)
        为公共利益实施新闻报道、舆论监督等行为，在合理的范围内处理个人信息；<br />
        e)
        在合理的范围内处理您自行公开的个人信息，或者其他已经合法公开的个人信息（如合法的新闻报道、政府信息公开等渠道合法公开的个人信息）；<br />
        f) 法律法规规定的其他情形。
      </p>
      <h3><a id="4_132"></a>4我们如何保护个人信息安全</h3>
      <p>
        <strong
          >4.1我们非常重视您个人信息的安全，将努力采取合理的安全措施（包括技术方面和管理方面）来保护您的个人信息，防止您提供的个人信息被不当使用或未经授权的情况下被访问、公开披露、使用、修改、损坏、丢失或泄漏。</strong
        ><br />
        4.2我们会使用不低于行业同行的加密技术、匿名化处理等合理可行的手段保护您的个人信息，并使用安全保护机制防止您的个人信息遭到恶意攻击。<br />
        4.3我们会建立专门的安全部门、安全管理制度、数据安全流程保障您的个人信息安全。我们采取严格的数据使用和访问制度，确保只有授权人员才可访问您的个人信息，并适时对数据和技术进行安全审计。<br />
        4.4尽管已经采取了上述合理有效措施，并已经遵守了相关法律规定要求的标准，但请您理解，由于技术的限制以及可能存在的各种恶意手段，在互联网行业，即便竭尽所能加强安全措施，也不可能始终保证信息百分之百的安全，我们将尽力确保您提供给我们的个人信息的安全性。您知悉并理解，您接入我们的服务所用的系统和通讯网络，有可能因我们可控范围外的因素而出现问题。因此，我们强烈建议您采取积极措施保护个人信息的安全，包括但不限于使用复杂密码、定期修改密码、不将自己的账号密码等个人信息透露给他人。<br />
        4.5我们会制定应急处理预案，并在发生用户信息安全事件时立即启动应急预案，努力阻止该等安全事件的影响和后果扩大。一旦发生用户信息安全事件（泄露、丢失等）后，我们将按照法律法规的要求，及时向您告知：安全事件的基本情况和可能的影响、我们已经采取或将要采取的处置措施、您可自主防范和降低风险的建议、对您的补救措施等。我们将及时将事件相关情况以推送通知、邮件、信函、短信等形式告知您，难以逐一告知时，我们会采取合理、有效的方式发布公告。同时，我们还将按照相关监管部门要求，上报用户信息安全事件的处置情况。<br />
        4.6我们谨此特别提醒您，本隐私政策提供的个人信息保护措施仅适用于画世界PRO软件及相关服务。一旦您离开画世界PRO及相关服务，浏览或使用其他网站、服务及内容资源，我们没有能力及义务保护您在画世界PRO软件及相关服务之外的软件、网站提交的任何个人信息，无论您登录、浏览或使用上述软件、网站是否基于画世界PRO的链接或引导。
      </p>
      <h3><a id="5_139"></a>5我们如何处理未成年人的个人信息</h3>
      <p>
        我们非常重视对未成年人个人信息的保护。若您是未成年人，在使用画世界Pro及相关服务前，应在您的父母或其他监护人监护、指导下共同阅读并同意本隐私政策。若您是未成年人的监护人，在使用画世界Pro及相关服务前，应为您的被监护人阅读并同意本隐私政策，当您对您所监护的未成年人的个人信息有相关疑问时，请通过本隐私政策公示的联系方式与我们联系。<br />
        我们根据国家相关法律法规的规定保护未成年人的个人信息，只会在法律允许、父母或其他监护人明确同意或保护未成年人所必要的情况下收集、使用、共享或披露未成年人的个人信息。您可以通过阅读<a
          href="https://staticpro.mjing.art/hsj/agreement/#/mojing/hsjpro/privacy/children"
          target="_blank"
          >《未成年人隐私保护》</a
        >了解更多信息。
      </p>
      <h3><a id="6_142"></a>6您的权利</h3>
      <p>
        我们非常重视您对个人信息的管理，并尽全力保护您对于您个人信息的<strong>查阅、复制、修改（更新或更正）、补充、删除您的个人信息、注销账号</strong>的权利。以使您有能力保障您的隐私和安全。您可以在下面指引进行操作。此外我们还设置了问题反馈渠道，您的意见和请求将会及时的处理。
      </p>
      <h4><a id="61_144"></a>6.1查询、复制个人信息</h4>
      <p>
        <strong>6.1.1查询头像、昵称、性别、地区信息</strong><br />
        1）进入应用后点击左上角头像；<br />
        2）点击个人资料；<br />
        3）进行信息查询访问；<br />
        <strong>6.1.2查询登录设备信息</strong><br />
        1)进入应用后点击左上角头像；<br />
        2）点击账号与安全<br />
        3）点击登录设备管理；<br />
        4）查询登录设备信息与登录时间；<br />
        <strong>6.1.3查阅《个人信息收集清单》</strong><br />
        1）进入应用后点击左上角头像；<br />
        2）点击关于；<br />
        3）点击个人信息收集清单进行查阅；<br />
        <strong>6.1.4查阅《第三方信息共享清单》</strong><br />
        1）进入应用后点击左上角头像；<br />
        2）点击关于；<br />
        3）点击第三方信息共享清单进行查阅；<br />
        <strong>6.1.5查阅《隐私政策》</strong><br />
        1）进入应用后点击左上角头像；<br />
        2）点击关于；<br />
        3）点击隐私政策进或在注册页面进行查阅；<br />
        <strong>6.1.6复制个人信息</strong><br />
        1）进入应用后点击左上角头像；<br />
        2）点击关于；<br />
        3）点击个人信息收集清单；<br />
        4）点击个人信息下载；
      </p>
      <h4><a id="62_171"></a>6.2删除个人信息</h4>
      <p>
        <strong>6.2.1删除登录设备信息</strong><br />
        1）进入应用后点击左上角头像；<br />
        2）点击账号与安全<br />
        3）点击登录设备管理；<br />
        4）点击删除可将设备移除；<br />
        <strong>6.2.2订单删除</strong><br />
        1）进入应用后点击底部发现；<br />
        2）点击集市更多按钮<br />
        3）点击集市右上角头像<br />
        4）点击需要删除的订单进入到订单详情<br />
        5）点击底部更多，选择删除订单
      </p>
      <h4><a id="63_183"></a>6.3修改、补充或更正个人信息</h4>
      <p>
        <strong>6.3.1更改头像、昵称、性别、地区基本信息</strong><br />
        1）进入应用后点击左上角头像；<br />
        2）点击个人资料；<br />
        3）点击相应信息进行操作；<br />
        <strong>6.3.1更改登录密码或手机号</strong><br />
        1）进入应用后点击左上角头像；<br />
        2）点击账号与安全；<br />
        3）点击相应信息进行操作；
      </p>
      <h4><a id="64_192"></a>6.4管理、撤回授权您的信息</h4>
      <p>
        您可以在设备的设置功能中开启或关闭<strong>摄像头、相册/照片与视频、存储/媒体影音、麦克风、蓝牙、通知</strong>等权限，改变授权范围或撤回您的授权。<br /> 应用内在<strong>头像-通用设置-管理存储权限和管理其他权限</strong>；安卓11以下在<strong>头像-通用设置-管理权限</strong>改变授权范围或撤回您的授权。<br />
        请您理解，特定的业务功能和服务将需要您的信息才能得以完成，当您撤回同意或授权后，我们无法继续为您提供授权所对应的功能和服务，也不再处理您相应的个人信息。但您撤回同意或授权的决定，不会影响公司此前基于您的授权而开展的个人信息处理。您可以阅读<a
          href="https://staticpro.mjing.art/hsj/agreement/#/permissions"
          target="_blank"
          >画世界PRO权限申请与使用情况说明</a
        >，以了解画世界PRO申请和使用系统权限的具体情况。
      </p>
      <h4><a id="65_195"></a>6.5注销您的账号</h4>
      <p>
        您可以在客户端应用程序中点击左上方【我的】进入个人中心，点击【账号与安全】-【注销账号】提交账号注销申请。在您注销账号前，我们将验证您的个人身份、账号状态、安全状态、<strong>设备信息</strong>以及未完成交易/服务情况等。您知悉并理解，注销账号的行为是不可逆的行为，当您注销账号后，我们将删除有关您账号的一切信息或对相关信息进行匿名化处理，但法律法规另有规定或为履行法定义务所必需保留的信息除外。如因账号存在未完成交易或服务、账号存在安全风险或争议、法律法规要求继续保存相关记录、需要完成身份验证或人工审核等原因暂时无法立即注销，我们会向您说明原因并依法处理。
      </p>
      <h4><a id="66_197"></a>6.6投诉举报</h4>
      <p>
        您可以按照我们公示的制度进行投诉或举报。如果您认为您的个人信息权利可能受到侵害，或者发现侵害个人信息权利的线索，您可以在客户端应用程序中点击左上方【我的】进入个人中心，点击【问题反馈】与我们联系，我们核查后会在15日内反馈您的投诉与举报。
      </p>
      <h3><a id="7_200"></a>7适用范围</h3>
      <p>
        本隐私权政策适用于由杭州摸鲸科技有限公司及其关联方提供的所有服务，包括画世界PRO客户端，不适用于有单独的隐私权政策且未纳入本隐私权政策的第三方产品或服务。<br />
        当您在使用我们的服务过程中接触到由第三方独立提供的产品/服务（包括但不限于广告服务）时，该等服务的隐私保护将遵循其运营者另行制定的隐私政策。我们建议您在使用前仔细阅读第三方提供的相关协议及政策文件，以便更好地了解其个人信息处理规则。<br />
        在您使用登录、支付、分享、云备份、广告跳转等功能时，可能会打开或跳转至第三方APP、小程序、网页或应用商店，例如微信、QQ、支付宝、百度网盘或广告落地页等。第三方服务由对应第三方独立提供，其个人信息处理规则适用第三方自行发布的隐私政策或个人信息保护规则。<br />
        在您主动选择使用第三方服务时，我们可能会基于服务必需原则依法依规共享必要信息。我们始终秉持审慎态度选择合作方，并对其信息安全能力进行必要审核。您可通过本政策&quot;第三方SDK清单&quot;章节查询具体合作方名录。<br />
        本隐私政策中所述的画世界PRO及相关服务有可能会根据您所使用的手机型号、系统版本、软件应用程序版本等因素而有所不同。最终的产品和服务以您所使用的画世界PRO软件及相关服务为准。<br />
        如对本隐私政策内容有任何疑问、意见或建议，您可通过登录画世界PRO客户端内的【我的】-【问题反馈】页面与我们联系。
      </p>
      <h3><a id="8_208"></a>8其他</h3>
      <p>
        本“隐私政策”中的标题仅为方便及阅读而设，并不影响本《隐私政策》中任何规定的含义或解释。<br />
        《隐私政策》是我们统一适用的一般性隐私条款，其中所规定的用户权利及信息安全保障措施均适用于画世界PRO用户。
      </p>
      <h3><a id="9_211"></a>9如何联系我们</h3>
      <p>
        杭州摸鲸科技有限公司将按照本政策保护您的信息。如您有关于网络信息安全的投诉和举报，或您对本政策、您的信息的相关事宜有任何问题、意见或建议，以及有关本政策或画世界PRO隐私措施的问题请与我们的协调人联系（画世界PRO客户端左上角【我的】-【问题反馈】）。<br />
        一般情况下，我们将在收到您的问题、意见或建议，并验证您的用户身份后的15天内予以回复。
      </p>
    </div>
  </div>
  <privacy-ios v-else></privacy-ios>
</template>
<script>
import { testPlatform } from "@/utils";

import PrivacyIos from "./ios/Privacy.vue";

export default {
  name: "MojingHsjProPrivacy",
  components: {
    PrivacyIos,
  },
  computed: {
    isIOS() {
      return testPlatform("ios");
    },
  },
};
</script>
<style lang="scss">
.privacy_pro {
  .container {
    font-size: 14px;
    overflow-x: auto;

    h1 {
      font-size: 24px;
    }

    .top__desc {
      font-size: 14px;
      text-indent: 2em;
      line-height: 2;
    }

    h6.subtitle {
      font-size: 14px;
      font-weight: normal;
      margin-top: 10px;
      margin-bottom: 10px;
    }

    .third-url-list {
      > a {
        display: block;
      }
    }

    li {
      > h2 {
        display: inline;
        font-size: 14px;
        font-weight: bold;

        + ol {
          margin-top: 15px;
        }
      }

      p {
        margin-top: 1em;
        margin-bottom: 0;
      }
    }
  }

  p {
    margin-top: 1em;
    margin-bottom: 0;
    line-height: 2;
  }

  a {
    // display: block;
    word-break: break-all;
    color: #1989fa;
    text-decoration: none;
  }

  table {
    color: #646466;
    font-size: 14px;
    border-spacing: 0;
    border: 1px solid #ebeef5;
    table-layout: fixed;
    // width: 100%;
    line-height: normal;
    text-indent: initial;
    text-align: center;

    tr {
      > th {
        padding: 8px 10px;
        white-space: nowrap;
        border-bottom: 1px solid #d9d9db;

        &:nth-child(1) { min-width: 110px; }
        &:nth-child(2) { min-width: 150px !important; }
        &:nth-child(3) { min-width: 140px; }
        &:nth-child(4) { min-width: 300px !important; }
        &:nth-child(5) { min-width: 110px; }
        &:nth-child(6) { min-width: 170px; }
      }
    }

    th,
    td {
      box-sizing: border-box;
      font-weight: normal;
      border-bottom: 1px solid #ebeef5;
      border-right: 1px solid #ebeef5;
    }

    td {
      padding: 10px 8px;
      vertical-align: middle;
      text-align: center;
      word-break: break-all;
    }
  }
  blockquote {
    margin: 0;
    padding: 0px;
    font-weight: bold;
    font-size: 14px;
    line-height: 2;
  }
}
</style>
